<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div class="columns">
        <div class="column">
          <p class="bold">Name</p>
          <BaseInput class="input" v-model="form.data.skill.fields.name.value" />
        </div>
        <div class="column">
          <p class="bold">Category</p>
          <BaseInput class="input" v-model="form.data.skill.fields.category.value" />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="bold">Option Order Asc</p>
          <BaseInput class="input" v-model="form.data.skill.fields.option_order_asc.value" />
        </div>
        <div class="column">
          <p class="bold">Priority</p>
          <BaseInput type="number" class="input" v-model="form.data.skill.fields.priority.value" />
        </div>
      </div>
      <div>
        <p class="bold">Question Text</p>
        <textarea type="text" class="input" v-model="form.data.skill.fields.question_text.value"></textarea>
      </div>
      <div>
        <p class="bold">Featured</p>
        <checkbox v-model="form.data.skill.fields.featured.value" :checked="form.data.skill.fields.featured.value"></checkbox>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
import BaseInput from '@/components/shared/atoms/BaseInput.vue'

export default {
  name: 'AdminSkillsForm',
  components: {
    Checkbox,
    BaseInput
  },
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getSkill({ id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        skill: {
          fields: {
            name: {
              value: form_data.name,
              has_error: false,
              validations: []
            },
            option_order_asc: {
              value: form_data.option_order_asc,
              has_error: false,
              validations: []
            },
            featured: {
              value: form_data.featured,
              has_error: false,
              validations: []
            },
            category: {
              value: form_data.category,
              has_error: false,
              validations: []
            },
            question_text: {
              value: form_data.question_text,
              has_error: false,
              validations: []
            },
            priority: {
              value: form_data.priority,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/skills/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
